(function (w) {
  var container = document.getElementById("ekomi-widget-container");
  var token = container.dataset.token;
  var customerId = container.dataset.customerId;

  w['_ekomiWidgetsServerUrl'] = (document.location.protocol == 'https:' ? 'https:' : 'http:') + '//widgets.ekomi.com';
  w['_customerId'] = customerId;
  w['_ekomiDraftMode'] = true;
  w['_language'] = 'fr';
  window.widgetCssLoaded = 1;

  if(typeof(w['_ekomiWidgetTokens']) !== 'undefined'){
    w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = token;
  } else {
    w['_ekomiWidgetTokens'] = new Array(token);
  }

  if(typeof(ekomiWidgetJs) == 'undefined') {
    ekomiWidgetJs = true;

    var scr = document.createElement('script');
    scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';
    scr.defer='defer';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(scr);
  }
  
//   setTimeout(function(){
//     var ratingValue = $('.edito-footer .global-rating').text();
//     var ratingCount = $('.edito-footer .revs-count > span').text();
//     var logo = $('.ins-custom-header--logo img').get(0);
//     $('.edito-footer').after('<div style="display:none" itemscope itemtype="https://schema.org/AggregateRating"> <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/Organization"> <img itemprop="image" src="'+logo.src+'" alt="Logo Franfinance"/> <span itemprop="name">Franfinance</span> <span itemprop="telephone">0826826555</span> <span itemprop="address">Franfinance 53 Rue du Port 92724 Nanterre</span> </div><span itemprop="ratingValue">'+ratingValue+'</span><span itemprop="bestRating">5</span><span itemprop="ratingCount">'+ratingCount+'</span></div>');
// }, 3000);
})(window);